import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaLiquidacoesComprovantesEmpenhoInicio: [],
    buscaLiquidacoesComprovantesEmpenhoSucesso: ['liquidacoesComprovantesEmpenho'],
    buscaLiquidacoesComprovantesEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
}

// Ação para busca completa
Creators.buscaLiquidacoesComprovantesEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaLiquidacoesComprovantesEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarLiquidacoesComprovantes(filtro)
            .then(response => dispatch(Creators.buscaLiquidacoesComprovantesEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaLiquidacoesComprovantesEmpenhoErro(error)))
    }
}

const buscaLiquidacoesComprovantesEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaLiquidacoesComprovantesEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaLiquidacoesComprovantesEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.liquidacoesComprovantesEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_LIQUIDACOES_COMPROVANTES_EMPENHO_INICIO]: buscaLiquidacoesComprovantesEmpenhoInicio,
    [Types.BUSCA_LIQUIDACOES_COMPROVANTES_EMPENHO_ERRO]: buscaLiquidacoesComprovantesEmpenhoErro,
    [Types.BUSCA_LIQUIDACOES_COMPROVANTES_EMPENHO_SUCESSO]: buscaLiquidacoesComprovantesEmpenhoSucesso,
})
